var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('search-bar'),_vm._v(" "),_c('domiciliation-contracts-table')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fc47fe5","hasScoped":true,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/DomiciliationContracts/DomiciliationContractsList.vue
// module id = 1959
// module chunks = 0